export const TIMELINE = 'TIMELINE';
export const WORK = 'WORK';
export const ONEWORK = 'ONEWORK';
// UI reducer types
export const SET_ERRORS = 'SET_ERRORS';
export const LOADING_UI = 'LOADING_UI';
export const CLEAR_ERRORS = 'CLEAR_ERRORS';
